<template>
  <div class="dropdown" ref="dropdownRef">
    <input
        type="text"
        :placeholder="placeholder"
        class="textbox"
        :style="inputStyle"
        :value="modelValue[field]"
        @input="handleInput"
        @click.stop="clickHandler"
    />

    <ul v-if="filteredList.length" class="dropdown-content" @click.stop>
      <li
          v-for="item in filteredList"
          :key="item[field]"
          @click="itemClick(item)"
      >
        {{ item[field] }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted} from 'vue'

const props = defineProps({
  modelValue: Object,          // v-model 绑定对象（必须保持）
  filteredList: Array,        // 下拉列表数据
  clickHandler: Function,     // 点击 input 时执行的方法
  itemClick: Function,        // 点击 li 时执行的方法
  placeholder: String,        // 输入框提示
  inputStyle: String,          // 输入框样式（用于第二个 dropdown）
  field:String
})

const emit = defineEmits(['update:modelValue','input','close'])
const dropdownRef = ref(null)

function handleInput(e) {
  props.modelValue[props.field] = e.target.value
  emit('input', e)
}

function handleClickOutside(e) {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target)) {
    emit('close')
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>